import React, { useRef, useEffect } from "react";

const formatDecimal = (value) => {
    if (value === "" || value === undefined || value === null) {
        return "0.000";
    }

    const stringValue = typeof value === 'number' ? value.toString() : value;

    const [intPart, decPart = ""] = stringValue.split(".");
    const cleanInt = intPart || "0";
    const cleanDec = decPart.padEnd(3, "0").slice(0, 3);
    return `${cleanInt}.${cleanDec}`;
};

const MaskedDecimalInput = ({ value, onChange, ...props }) => {
    const inputRef = useRef(null);

    useEffect(() => {
        if (value === "" || value === undefined || value === null) {
            onChange("0.000");
        }
    }, []);

    const handleInput = (e) => {
        const input = inputRef.current;
        let raw = input.value.replace(/[^0-9.]/g, "");

        if (raw === "") {
            onChange("0.000");
            return;
        }

        if (!raw.includes(".")) {
            raw += ".000";
        }

        const [intPart, decPart = ""] = raw.split(".");
        let finalDecPart = decPart.padEnd(3, "0").slice(0, 3);
        let newValue = `${intPart || "0"}.${finalDecPart}`;

        onChange(newValue);
    };

    const handleKeyDown = (e) => {
        const input = inputRef.current;
        const [intPart, decPart = ""] = value.split(".");
        const cursorPos = input.selectionStart;

        if ((e.key === "," || e.key === ".") && !value.includes(".")) {
            e.preventDefault();
            const newValue = `${intPart || "0"}.000`;
            onChange(newValue);
            setTimeout(() => {
                input.setSelectionRange(newValue.indexOf(".") + 1, newValue.indexOf(".") + 1);
            }, 0);
        }

        if (/^\d$/.test(e.key) && cursorPos > value.indexOf(".")) {
            e.preventDefault();
            const positionInDec = cursorPos - value.indexOf(".") - 1;
            const updatedDec =
                decPart.substring(0, positionInDec) +
                e.key +
                decPart.substring(positionInDec + 1);
            const newValue = `${intPart}.${updatedDec}`;
            onChange(newValue);
            setTimeout(() => {
                const newPos = Math.min(cursorPos + 1, value.indexOf(".") + 4);
                input.setSelectionRange(newPos, newPos);
            }, 0);
        }
    };

    return (
        <input
            {...props}
            ref={inputRef}
            value={formatDecimal(value)}
            onChange={handleInput}
            onKeyDown={handleKeyDown}
        />
    );
};

export default MaskedDecimalInput;